import React, { useEffect } from 'react';
import Loading from 'components/commons/loading/Loading';
import * as env from 'config/environment';
import { useParams } from 'react-router-dom';
import { formatDateForString } from 'utils/formatter';
import { useRouting } from 'hooks/useRouting';
import { DisclaimerProps, useDisclaimer } from 'hooks/useDisclaimer';
import { useCustomizeHeaderContext } from 'contexts/CustomizeHeaderContext';

const Importantnotification: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { setCustomTitle } = useCustomizeHeaderContext();

  const { disclaimers, isLoading, isRefetching } = useDisclaimer();

  const routing = useRouting();
  const back = (): void => {
    routing.backRouting(true);
  };
  useEffect(() => {
    return () => setCustomTitle('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (
    disclaimers === undefined ||
    disclaimers === null ||
    isLoading ||
    isRefetching
  )
    return (
      <>
        <Loading
          loading={true}
          style={{
            paddingTop: '180px',
            paddingBottom: '180px',
          }}
        />
      </>
    );

  const disclaimer = disclaimers.find(
    (disclaimer: DisclaimerProps) => disclaimer.ID === id
  );

  if (disclaimer === undefined) return <></>;

  if (disclaimer.title) {
    setCustomTitle(disclaimer.title);
  }

  const autoLink = (content: string): string => {
    const newContent = unescape(content ?? '');

    // コメントの部分は、正規表現（/〜/）を解釈してくれないエディタ等で自動整形を崩さないため
    // url[text] -> ]url: リンクURL、text: リンク文字列
    const regexpUrl = /(?<url>https?:\/\/[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#]+)(\[:b (?<text>.*)\]){0,1}/g; // ']))/;

    return newContent.replace(regexpUrl, (...args) => {
      const groups = args.pop();
      const url = groups['url'];
      const text = groups['text'];

      // アプリケーション内へのリンク -> 同じタブ、それ以外 -> 別タブ で開く
      const target = url.startsWith(env.appURL) ? '' : 'target="_blank"';
      return `<a class=${'underline'} href="${url}" ${target}>${text}</a>`;
    });
  };

  const createContent = (
    content: string | undefined
  ): {
    __html: string;
  } => {
    return { __html: autoLink(unescape(content ?? '')) };
  };

  return (
    <>
      <div className="relative">
        <div className="ml-2 mr-2 mt-2 px-4 pt-6 pb-4 bg-white">
          <div className="text-lg font-bold mb-2 text-bluegray-700">
            {disclaimer.title}
          </div>
          <div className="mt-6">
            {disclaimer.content ? (
              <div
                className="whitespace-pre-wrap"
                id="contentWithAutoLink"
                dangerouslySetInnerHTML={createContent(disclaimer.content)}
              />
            ) : (
              <></>
            )}
            <div className="mt-4 text-xs text-bluegray-500">
              {formatDateForString(disclaimer.updTime, 'yyyy/M/d')} 改訂
            </div>
          </div>
          <div
            className="flex justify-center text-bluegray-500 mx-1 my-2 p-2 cursor-pointer"
            onClick={back}>
            戻る
          </div>
        </div>
      </div>
    </>
  );
};

export default Importantnotification;
